export default __webpack_public_path__ + "static/media/marvel.4e2dde32.svg";